import React from "react";
import classes from "./DashboardCard.module.css";

export default function DashboardCard({ data, index }) {
  const colorArr = [
    "rgba(166, 1, 17, 0.4)",
    "rgba(94, 214, 149, 0.4)",
    "rgba(225, 206, 104, 0.4)",
    "rgba(229, 152, 108, 0.4)",
  ];
  return (
    <div
      className={classes.dashboard_card}
      style={{ "--card-background-color": colorArr[index] }}
    >
      <h3>
        {" "}
        {data?.name
          ? data.name.charAt(0).toUpperCase() + data.name.slice(1).toLowerCase()
          : "N/A"}
      </h3>
      <h2>{data?.count || 0}</h2>
    </div>
  );
}
